// 1. 외부 패키지
import { useRecoilValue } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import media_atom from "../../atom/media-atom";
import get_basic_detail_selector from "../../selector/get-basic-detail-selector";
import { comma, getQuery } from "../../shared/function";
import basic_detail_atom from "../../atom/basic-detail";

// 4. 타입

const Detail = () => {

	const media = useRecoilValue(media_atom);

	const data = useRecoilValue(get_basic_detail_selector(getQuery().idx));

	const { overview, purpose, attract_type } = data;

	const basic_detail = useRecoilValue(basic_detail_atom);

	const k = basic_detail.area_type === 'PY' ? '평' : 'm²';

	let avg_price = overview?.avg_route_price ?? undefined;
	let set_area = overview?.set_area ?? undefined;

	if(basic_detail.area_type === 'PY') {
		avg_price = avg_price ? avg_price * (set_area ?? 0) : undefined;
		set_area = set_area ? set_area / 3.3058 : undefined;

		avg_price = avg_price && set_area ? Math.round(avg_price / set_area) : undefined;
		set_area = set_area ? Math.round(set_area) : undefined;
	}

	return (
		<article className="more_info ic_base_info">
			<div className="desc_text ws-bs" style={{ marginTop : media === "P" ? 40 : 25 }}>
				<h2>사업개요</h2>
				<table>
					<colgroup>
						<col width="15%"/>
            <col width="35%"/>
            <col width="15%"/>
            <col width="*"/>
					</colgroup>
					<tbody>
						<tr className="top_line">
							<th>단지명</th>
							<td>{overview.name ?? '데이터없음'}</td>
							<th>단지 유형</th>
							<td>{overview.type ?? '데이터없음'}</td>
						</tr>
						<tr>
							<th>조성상태</th>
							<td>{overview.design_status ?? '데이터없음'}</td>
							<th>분양상태</th>
							<td>{overview.route_status ?? '데이터없음'}</td>
						</tr>
						<tr>
							<th>위치</th>
							<td colSpan={3}>{overview.address ?? '데이터없음'}</td>
						</tr>
						<tr>
							<th>조성목적 및 특징</th>
							<td
								colSpan={3}
								style={{paddingLeft: '5px', textAlign: 'left'}}
								dangerouslySetInnerHTML={{
									__html: purpose?.length > 0
									? purpose.map((item) => item.purpose).join('<br/>')
									: '데이터없음'}}
								/>
						</tr>
						<tr>
							<th>사업기간(년월)</th>
							<td colSpan={3}>{overview.business_schedule ?? '데이터없음'}</td>
						</tr>
						<tr>
							<th>산업용지 평균분양가<br/>(원/{k})</th>
							<td>{avg_price ? `${comma(avg_price ?? 0)}원` : '데이터없음'}</td>
							<th>지정일</th>
							<td>{overview.set_date ?? '데이터없음'}</td>
						</tr>
						<tr>
							<th>지정면적</th>
							<td>{set_area ? `${comma(set_area ?? 0)}${k}` : '데이터없음'}</td>
							<th>조성공정률</th>
							<td>{overview.route_rate ? `${overview.route_rate}%` : '데이터없음'}</td>
						</tr>
						<tr>
							<th>실시승인일</th>
							<td>{overview.accept_date ?? '데이터없음'}</td>
							<th>준공만기일</th>
							<td>{overview.work_end_date ?? '데이터없음'}</td>
						</tr>
						<tr>
							<th>사업시행자명</th>
							<td>{overview.corp ?? '데이터없음'}</td>
							<th>관리기관명</th>
							<td>{overview.organize ?? '데이터없음'}</td>
						</tr>
					</tbody>
				</table>

				<h2>유치업종</h2>
				<ul className='attract_type_ul'>
					{attract_type.map((item, index) => {
						return (
							<li className='attract_type_li' key={index}>
								<span className='attract_type_span'>{item.m_contents}</span>
								{item.m_name}
							</li>
						);
					})}
				</ul>
			</div>
		</article>
	);
};

export default Detail;